import { useQuery } from "@/api/swr/useQuery";
import { assessorSchema } from "@/schema/console/assessors/Assessor";
import { z } from "zod";

export function useGetAssessors() {
  return useQuery(z.array(assessorSchema), "/console/admin_users");
}
